// Geolocalização via GeoJS (gratuito, sem token).
// Substitui ipinfo.io para não expor credenciais no client-side.

document.addEventListener('DOMContentLoaded', function () {
  // Passo 1: Obter valor do frete do localStorage (já salvo pela API)
  let valueTax = localStorage.getItem('valueTax');
  if (!valueTax) {
    valueTax = 299;
  } else {
    valueTax = parseFloat(valueTax);
  }

  // Passo 2: Obter valor total do carrinho do atributo data
  const bar = document.getElementById('shipping-bar');
  if (!bar) return;
  const totalCart = parseFloat(bar.getAttribute('data-cart-total'));

  // Passo 3: Calcular progresso
  const progress = Math.min((totalCart / valueTax) * 100, 100).toFixed(2);
  const valorRestante = (valueTax - totalCart).toFixed(2);

  const fill = document.getElementById('shipping-fill');
  const text = document.getElementById('shipping-text');
  if (!fill || !text) return;

  fill.style.width = `${progress}%`;

  if (totalCart >= valueTax) {
    text.innerText = "Parabéns você ganhou frete grátis!";
  } else {
    text.innerText = `Falta R$ ${valorRestante.replace('.', ',')} para obter frete grátis`;
  }
});

// Detecção de região via GeoJS — endpoint gratuito sem necessidade de token.
// Estados Sul/Sudeste têm threshold menor (R$199); demais R$299.
fetch('https://get.geojs.io/v1/ip/geo.json')
  .then(response => response.json())
  .then(data => {
    const region = data.region;
    let valueTax = 299;
    const regioesEspeciais = [
      "São Paulo", "Rio de Janeiro", "Paraná",
      "Rio Grande do Sul", "Santa Catarina",
      "Minas Gerais", "Espírito Santo"
    ];
    if (regioesEspeciais.includes(region)) {
      valueTax = 199;
    }
    localStorage.setItem('valueTax', valueTax);
  })
  .catch(() => {
    // Fallback: mantém valor padrão R$299
    localStorage.setItem('valueTax', 299);
  });
